import { Component, OnInit } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-test-rest-api',
  templateUrl: './test-rest-api.component.html',
  styleUrls: ['./test-rest-api.component.scss'],
})
export class TestRestApiComponent implements OnInit {
  restApiDataInfo: any;
  isRestApiListingDisplay: boolean;

  constructor(public settingService: SettingService) {
    this.isRestApiListingDisplay = true;
  }

  ngOnInit() {}

  public onRestApiDataInfo(restApiDataInfo: any) {
    this.restApiDataInfo = restApiDataInfo;
    console.log(restApiDataInfo);
    if (restApiDataInfo != undefined && restApiDataInfo.screenReqdFl == 'YES')
      this.isRestApiListingDisplay = false;
  }
}
